import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface DepartmentUploadRequirementControlProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function DepartmentUploadRequirementControl({
  name,
  id,
  disabled,
}: DepartmentUploadRequirementControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      disabled={disabled}
      label="Require departments"
    />
  );
}
